import axios from '../../../interceptor'
import routes from '../routes'

export default {
  getComingSource() {
    return axios.get(routes.tagsComingSource)
  }
}
